import Container from "@/components/ui/Container";
import SectionHeader from "@/components/ui/SectionHeader";
import { UserAvatar } from "./icons/ChatAvatars";

const questions = [
  "Какие сервисы с наибольшей вероятностью нарушат SLO в ближайшие 72 часа?",
  "Какие деградации инфраструктуры за последние 30 дней влияют на конверсию checkout?",
  "Какие изменения после релизов ухудшают p99 latency?",
  "Какие инциденты чаще всего приводят к расходу error budget?",
];

export default function AICapabilitiesSection() {
  return (
    <section>
      <Container>
        <SectionHeader
          label="Какие задачи решает ИИ"
          heading="ИИ анализирует все доступные данные"
        >
          <div className="mt-[40px] flex flex-col gap-2.5 min-[478px]:gap-5 min-[478px]:mt-[60px] xl:mt-[90px]">
            {questions.map((question) => (
              <div
                key={question}
                className="flex items-start gap-[13px] rounded-[16px] bg-surface p-[26px]"
              >
                <span className="flex h-[22px] shrink-0 items-center min-[478px]:h-[29px]">
                  <UserAvatar className="size-[26px]" />
                </span>

                <p className="text-[16px] font-bold leading-snug text-[#1c3564] min-[478px]:text-[21px]">
                  {question}
                </p>
              </div>
            ))}
          </div>
        </SectionHeader>
      </Container>
    </section>
  );
}
